const DEFAULT_FLAGS = {
  ff_web_coin: false,
  PRODUCT_SEND_RECEIVE_ENABLED: false,
  STOCK_EIPO_TRANSACTION_FEE_SECTION: { enable: false },
  STOCK_DT_CONFIRM_DISCLAIMER: { disclaimers: [] },
};

export default DEFAULT_FLAGS;
